// Angular imports
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'concat',
    standalone: false
})
export class ConcatPipe implements PipeTransform {
	public transform(...values: string[]): string {
		return values.join('');
	}
}
